module.exports = __webpack_public_path__ + "img/default.b1e06804.png";